import { Suspense } from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './config/msal';
import { MsalProvider } from '@azure/msal-react';
import Providers from './providers/Providers';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import { MantineProvider } from '@mantine/core';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { emotionTransform, MantineEmotionProvider } from '@mantine/emotion';
export const msalInstance = new PublicClientApplication(msalConfig);
import { theme } from './theme';
import { Notifications } from '@mantine/notifications';
import './utils/react-hot-toast-override';

const App = () => {
  return (
    <MsalProvider instance={msalInstance}>
      <Suspense fallback={<div>Loading...</div>}>
        <MantineProvider theme={theme} stylesTransform={emotionTransform}>
          <MantineEmotionProvider>
            <Notifications zIndex={999999} />
            <Providers />
          </MantineEmotionProvider>
        </MantineProvider>
      </Suspense>
    </MsalProvider>
  );
};

export default App;
